"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="call-to-action" className="bg-[#38457c] py-[160px] px-6 overflow-hidden">
      <div className="container mx-auto max-w-4xl">
        <div ref={ref} className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-12 max-w-3xl">If you want support that is clear, useful and applicable, get in touch.</h2>

          <div className="flex flex-col items-center justify-center w-full">
            <Button asChild size="lg" className="w-full sm:w-auto rounded-lg text-base h-14 px-8 shadow-lg hover:shadow-xl transition-all bg-[#efc318] text-[#38457c] hover:bg-[#efc318]/90 border-none">
              <Link to="#">
                Book a free consultation
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}